
import WebIcon from 'vue-material-design-icons/Web.vue'

import { t } from '@nextcloud/l10n'

import NcAvatar from '@nextcloud/vue/dist/Components/NcAvatar.js'
import NcLoadingIcon from '@nextcloud/vue/dist/Components/NcLoadingIcon.js'

import { useIsDarkTheme } from '../../composables/useIsDarkTheme.ts'
import { ATTENDEE, AVATAR } from '../../constants.js'
import { getUserProxyAvatarOcsUrl } from '../../services/avatarService.ts'

export default {

	name: 'AvatarWrapper',

	components: {
		NcAvatar,
		WebIcon,
		NcLoadingIcon,
	},

	props: {
		token: {
			type: String,
			default: null,
		},
		name: {
			type: String,
			required: true,
		},
		id: {
			type: String,
			default: null,
		},
		source: {
			type: String,
			default: null,
		},
		size: {
			type: Number,
			default: AVATAR.SIZE.DEFAULT,
		},
		condensed: {
			type: Boolean,
			default: false,
		},
		condensedOverlap: {
			type: Number,
			default: 2,
		},
		offline: {
			type: Boolean,
			default: false,
		},
		highlighted: {
			type: Boolean,
			default: false,
		},
		disableTooltip: {
			type: Boolean,
			default: false,
		},
		disableMenu: {
			type: Boolean,
			default: false,
		},
		showUserStatus: {
			type: Boolean,
			default: false,
		},
		showUserStatusCompact: {
			type: Boolean,
			default: false,
		},
		preloadedUserStatus: {
			type: Object,
			default: undefined,
		},
		menuContainer: {
			type: String,
			default: undefined,
		},

		loading: {
			type: Boolean,
			default: false,
		},
	},

	setup() {
		const isDarkTheme = useIsDarkTheme()
		return {
			isDarkTheme,
		}
	},

	computed: {
		// Determines which icon is displayed
		iconClass() {
			if (!this.source || this.isUser || (this.isFederatedUser && this.token) || this.isBot || this.isGuest || this.isDeletedUser) {
				return ''
			}
			if (this.isFederatedUser) {
				return 'icon-user'
			}
			if (this.source === ATTENDEE.ACTOR_TYPE.EMAILS) {
				return 'icon-mail'
			}
			if (this.source === ATTENDEE.ACTOR_TYPE.PHONES) {
				return 'icon-phone'
			}
			if (this.source === ATTENDEE.ACTOR_TYPE.BOTS && this.id === ATTENDEE.CHANGELOG_BOT_ID) {
				return 'icon-changelog'
			}
			if (this.source === ATTENDEE.ACTOR_TYPE.CIRCLES) {
				return 'icon-team'
			}
			// source: groups
			return 'icon-contacts'
		},
		avatarClass() {
			return {
				'avatar-wrapper--dark': this.isDarkTheme,
				'avatar-wrapper--offline': this.offline,
				'avatar-wrapper--condensed': this.condensed,
				'avatar-wrapper--highlighted': this.highlighted,
			}
		},
		avatarStyle() {
			return {
				'--avatar-size': this.size + 'px',
				'--condensed-overlap': this.condensedOverlap,
			}
		},
		isUser() {
			return this.source === ATTENDEE.ACTOR_TYPE.USERS || this.source === ATTENDEE.ACTOR_TYPE.BRIDGED
		},
		isFederatedUser() {
			return this.source === ATTENDEE.ACTOR_TYPE.FEDERATED_USERS
		},
		isBot() {
			return this.source === ATTENDEE.ACTOR_TYPE.BOTS && this.id !== ATTENDEE.CHANGELOG_BOT_ID
		},
		isGuest() {
			return this.source === ATTENDEE.ACTOR_TYPE.GUESTS
		},
		isDeletedUser() {
			return this.source === 'deleted_users'
		},
		firstLetterOfGuestName() {
			if (this.isDeletedUser) {
				return 'X'
			}
			const customName = this.name?.trim() && this.name !== t('spreed', 'Guest') ? this.name : '?'
			return customName.charAt(0)
		},
		avatarUrl() {
			return getUserProxyAvatarOcsUrl(this.token, this.id, this.isDarkTheme, this.size > AVATAR.SIZE.MEDIUM ? 512 : 64)
		},
	},

	methods: {
		t,
	},
}
